
import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import dayjs from 'dayjs'
import moment from 'moment'

@Component
export default class DataSelect extends Vue {
  @Prop({default: {startTime: dayjs().format('YYYY-MM-DD'), endTime: dayjs().format('YYYY-MM-DD'),}})
  defaultTimes?: any //默认的时间筛选范围
  @Prop({default: 1}) defaulttimeType?: number // 默认的时间筛选类型
  readonly timeTypeList = [
    {
      value: 1,
      text: '当天'
    },
    {
      value: 11,
      text: '近30天'
    },
    {
      value: 2,
      text: '上周'
    },
    {
      value: 3,
      text: '本周'
    },
    {
      value: 4,
      text: '上月'
    },
    {
      value: 5,
      text: '本月'
    },
    {
      value: 6,
      text: '上季度'
    },
    {
      value: 7,
      text: '本季度'
    },
    {
      value: 8,
      text: '上年'
    },
    {
      value: 9,
      text: '本年'
    },
    {
      value: 10,
      text: '自定义'
    }
  ]
  readonly format = 'YYYY-MM-DD'
  minDate = new Date(dayjs().add(-2, 'year').format('YYYY-MM-DD')) // 默认2年前
  maxDate = new Date(dayjs().add(10, 'year').format('YYYY-MM-DD')) // 默认10年后
  timeTypeActive = 1
  showCalendar = false
  dataParams = {
    startTime: dayjs().format(this.format),
    endTime: dayjs().format(this.format),
  }

  defaultDate = [new Date(this.dataParams.startTime), new Date(this.dataParams.endTime)]

  get fullTime () {
    return this.dataParams.startTime + '~' + this.dataParams.endTime
  }

  created () {
    this.$nextTick(() => {
      this.dataParams.startTime = this.defaultTimes.startTime
      this.dataParams.endTime = this.defaultTimes.endTime
      this.timeTypeActive = this.defaulttimeType
      this.defaultDate = [new Date(this.dataParams.startTime), new Date(this.dataParams.endTime)]
    })
  }

  handleTimeTypeChange (val) {
    if (val !== 10) {
      const dateRange = this.getDateRange(this.timeTypeActive)
      this.dataParams.startTime = dateRange[0]
      this.dataParams.endTime = dateRange[1]
      this.defaultDate = [new Date(this.dataParams.startTime), new Date(this.dataParams.endTime)]
    } else {
      this.showCalendar = true
    }
    this.$emit('load', [this.dataParams.startTime, this.dataParams.endTime])
  }

  onConfirm (val) {
    this.timeTypeActive = val
    if (val !== 10) {
      const dateRange = this.getDateRange(this.timeTypeActive)
      this.dataParams.startTime = dateRange[0]
      this.dataParams.endTime = dateRange[1]
      this.defaultDate = [new Date(this.dataParams.startTime), new Date(this.dataParams.endTime)]
    } else {
      this.showCalendar = true
    }
    this.$emit('load', [this.dataParams.startTime, this.dataParams.endTime]);
    (this.$refs.dropdown as any).toggle();
  }

  timeTypeOpen () {
    // if (this.timeTypeActive === 10) {
    //   this.showCalendar = true
    // }
  }

  getDateRange (key: number) {
    let startTime = ''
    let endTime = ''
    const quarterStart = [-1, 0, 3, 6, 9]
    const quarterEnd = [-1, 2, 5, 8, 11]
    if (key === 1) {
      startTime = moment().format(this.format)
      endTime = moment().format(this.format)
    } else if (key === 2) {
      let weekOfday = parseInt(moment().format('d')) // 计算今天是这周第几天  周日为一周中的第一天
      // 获取上周的时间范围
      if (weekOfday === 0) {
        startTime = moment().subtract(13, 'days').format(this.format) // 周一日期
        endTime = moment().subtract(7, 'days').format(this.format) // 周日日期
      } else {
        startTime = moment().subtract(weekOfday + 6, 'days').format(this.format) // 周一日期
        endTime = moment().subtract(weekOfday, 'days').format(this.format) // 周日日期
      }
    } else if (key === 3) {
      let weekOfday = parseInt(moment().format('d')) // 计算今天是这周第几天  周日为一周中的第一天
      // 获取本周的时间范围
      if (weekOfday === 0) {
        startTime = moment().subtract(weekOfday + 6, 'days').format(this.format) // 周一日期
        endTime = moment().subtract(weekOfday, 'days').format(this.format) // 周日日期
      } else {
        startTime = moment().subtract(weekOfday - 1, 'days').format(this.format) // 周一日期
        endTime = moment().format(this.format) // 周日日期
      }
    } else if (key === 4) {
      // 获取上月的时间范围
      startTime = moment().month(moment().month() - 1).date(1).format(this.format)
      endTime = moment().month(moment().month() - 1).date(this.getMonthDay(moment().month(moment().month() - 1).year(), moment().month() - 1)).format(this.format)
    } else if (key === 5) {
      // 获取本月的时间范围
      startTime = moment().month(moment().month()).date(1).format(this.format)
      endTime = moment().month(moment().month()).date(this.getMonthDay(moment().year(), moment().month())).format(this.format)
    } else if (key === 6) {
      // 获取上季度的时间范围
      startTime = moment().quarter(moment().quarter() - 1).startOf('quarter').format('YYYY-MM-DD')
      endTime = moment().quarter(moment().quarter() - 1).endOf('quarter').format('YYYY-MM-DD')
    } else if (key === 7) {
      // 获取本季度的时间范围
      startTime = moment().month(quarterStart[moment().quarter()]).date(1).format(this.format)
      endTime = moment().month(quarterEnd[moment().quarter()]).date(this.getMonthDay(moment().year(), quarterEnd[moment().quarter()])).format(this.format)
    } else if (key === 8) {
      // 获取上年的时间范围
      startTime = `${moment().year() - 1}-01-01`
      endTime = `${moment().year() - 1}-12-${this.getMonthDay(moment().year() - 1, 11)}`
    } else if (key === 9) {
      // 获取本年的时间范围
      startTime = `${moment().year()}-01-01`
      endTime = `${moment().year()}-12-${this.getMonthDay(moment().year(), 11)}`
    } else if (key === 11) {
      // 获取近30天的时间范围
      startTime = `${moment().subtract(30, 'days').format(this.format)}`
      endTime = `${moment().format(this.format)}`
    }
    return [startTime, endTime]
  }

  getMonthDay (year: number, month: number) {
    let days = new Date(year, month + 1, 0).getDate()
    return days
  }

  onConfirmData (value) {
    this.showCalendar = false
    this.dataParams.startTime = dayjs(value[0]).format(this.format)
    this.dataParams.endTime = dayjs(value[1]).format(this.format)
    this.$emit('load', [this.dataParams.startTime, this.dataParams.endTime])
  }
}
